import { render, staticRenderFns } from "./PopWarning.vue?vue&type=template&id=4e862126&lang=pug"
import script from "./PopWarning.vue?vue&type=script&lang=js"
export * from "./PopWarning.vue?vue&type=script&lang=js"
import style0 from "./PopWarning.vue?vue&type=style&index=0&id=4e862126&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports